<template>
  <div v-if="$template" class="relative campaign-container">
    <Cart v-if="modalCart" @closeModal="closeModal" @removeFromCart="removeFromCart" @addToCart="addToCart" />
    <div>
      <img v-if="$template.products_picture" :src="imgUrl(
        $template.products_picture,
        'campaign_product_personnalisation'
      )
        " alt="" class="m-auto my-4" />

      <div v-if="$template.campaign_template_mechanic_id !== 2 || isGameFinish"
        class="flex justify-end mt-4 mr-2 lg:mr-0" style="position: sticky;top: 20px;z-index:98;">
        <button class="button-cart text-normal" @click="modalCart = true; scriptOpenCart()">
          {{ tagText($template.cart_text) }}
        </button>
      </div>

      <div>
        <div v-if="$template.campaign_template_mechanic_id === 5 && $store.isWheelWinner &&  $store.wheelWinner.voucher" class="mt-4 text-normal" :style="getProductText($template)" v-html="tagText($template.products_text_win, $store.wheelWinner.voucher)">
        </div>
        <div v-else class="mt-4 text-normal" :style="getProductText($template)" v-html="tagText($template.products_text)">
        </div>
         

        <div v-if="$template.campaign_template_mechanic_id !== 2">
          <div v-if="$template.mandatory_purchase || ($template.campaign_template_mechanic_id === 5 && $store.isWheelWinner)" >
            <p class="m-auto w-fit mt-4 font-bold text-[14px] lg:text-[24px]">
              Voici votre numéro de participation
            </p>
            <CodeTable :code="code1.value.toString()" />
          </div>
          <div v-else>
            <p class="m-auto w-fit mt-4 font-bold text-[14px] lg:text-[24px]">
              Voici votre 2ème numéro de participation
            </p>
            <CodeTable :code="code2.value.toString()" />
          </div>
        </div>

        <div v-else-if="$template.campaign_template_mechanic_id === 2">
          <Bandit @endGame="playedGame()"
            :code="$template.mandatory_purchase ? code1.value.toString() : code2.value.toString()"
            :alreadyPlay="$store.participation.play_bandit" :isFirst="$template.mandatory_purchase ? true : false" />
        </div>

        <div v-if="$template.campaign_template_mechanic_id !== 2 || isGameFinish">

          <div v-if="$template.campaign_template_mechanic_id === 5 && $store.isWheelWinner &&  $store.wheelWinner.voucher" class="py-4 text-normal" :style="getProductText2($template)" v-html="tagText($template.products_text2_win, $store.wheelWinner.voucher)">
          </div>
          <div v-else class="py-4 text-normal" :style="getProductText2($template)" v-html="tagText($template.products_text2)">
          </div>

          <div v-if="$template.enseigne_id === 3">
            <IVF @addToCart="addToCart" />
          </div>
          <div v-else-if="$template.enseigne_id === 5">
            <CAVE @addToCart="addToCart" />
          </div>
          <div v-else-if="$template.enseigne_id === 4">
            <NS @addToCart="addToCart" />
          </div>
          <div v-else>
            <DG_DDA @addToCart="addToCart" />
          </div>
        </div>
      </div>

      <div v-if="$template.campaign_template_mechanic_id !== 2 || isGameFinish"
        class="flex flex-col-reverse lg:flex-row justify-center mt-6 pb-12">
        <button class="button-cancel flex flex-col lg:mr-4 !px-4 !w-fit mx-auto lg:mx-0 !mt-4 lg:!mt-0"
          @click="goToEnd()">
          <p class="w-full text-center w-full font-normal" v-html="tagText($template.products_cancel)">
          </p>
        </button>

        <button class="button-validation flex flex-col !px-4 !w-fit !mt-0 mx-auto lg:mx-0" @click="goToResume()">
          <p class="w-full text-center w-full font-bold" v-html="tagText($template.products_validate)">
          </p>
        </button>
      </div>
    </div>
    <Ingredients v-if="$template.campaign_template_mechanic_id !== 2 || isGameFinish" />
  </div>
</template>

<script>
import CodeTable from '../common/components/CodeTable.vue'
import IVF from '../common/components/Products/IVF.vue'
import NS from '../common/components/Products/NS.vue'
import DG_DDA from '../common/components/Products/DG_DDA.vue'
import CAVE from '../common/components/Products/CAVE.vue'
import Ingredients from '../common/components/Ingredients.vue'
import Cart from '../common/components/Cart.vue'
import Bandit from '../common/components/Bandit.vue'

export default {
  components: {
    DG_DDA,
    CAVE,
    NS,
    IVF,
    CodeTable,
    Ingredients,
    Cart,
    Bandit
  },
  emits: ['openModal', 'openNotification'],
  data: () => ({
    modalCart: false,
    loading: true,
    isGameFinish: false,
  }),
  computed: {
    code1() {
      return this.$store.participationCode1 ?? null
    },
    code2() {
      return this.$store.participationCode2 ?? null
    },
    // Vérifie si c'est un winner wheel (pas de participation classique)
    isWheelWinner() {
      return this.$store.isWheelWinner && this.$store.wheelWinner?.token
    }
  },
  methods: {
    async playedGame() {
      this.isGameFinish = true
      const res = await this.$api.playBandit(this.$store.participation.id)
      this.$store.participation.play_bandit = true
    },
    getProductText(template) {
      return (
        'background-color: ' +
        template.products_text_background_color +
        ';'
      )
    },
    getProductText2(template) {
      return (
        'background-color: ' +
        template.products_text_background_color2 +
        ';'
      )
    },
    goToResume() {
      if (this.$store.cart.length == 0) {
        this.$emit(
          'openNotification',
          'Vous devez ajouter au moins un produit à votre panier pour continuer',
          true
        )
        return
      }
      this.$router.push({ name: 'resume' })
    },
    goToEnd() {
      this.$store.setIsCancel(true)
      this.$router.push({ name: 'end' })
    },
    scriptOpenCart() {
      //open cart
      if (!window.location.href.includes('localhost') && !window.location.href.includes('digiworks')) {
        this.$gtm.trackEvent({
          event: "view_cart",
          campaignid: this.$campaign.code
        });
      }
    },
    async addToCart(product) {
      this.$emit(
        'openNotification',
        "L'article " +
        this.$store.getProductById(product.id).name +
        ' a bien été ajouté à votre panier.'
      )

      try {
        // Pour les winners wheel, utiliser l'API wheel
        if (this.isWheelWinner) {
          const newCart = this.$store.cart.filter(item => item.id !== product.id)
          newCart.push(product)
          const res = await this.$api.wheelUpdateCart(
            this.$store.wheelWinner.token,
            newCart
          )
          this.$store.updateCart(res.data.cart)
        } else {
          // API classique pour les participations normales
          const res = await this.$api.syncCart(this.$store.participation.id, {
            action: 'add',
            product
          })
          this.$store.updateCart(res.data.cart)
        }

        //add to cart
        if (!window.location.href.includes('localhost') && !window.location.href.includes('digiworks')) {
          this.$gtm.trackEvent({
            event: "add_to_cart",
            campaignid: this.$campaign.code
          });
        }

      } catch (e) {
        console.log(e)
      }
    },
    async removeFromCart(id) {
      try {
        // Pour les winners wheel, utiliser l'API wheel
        if (this.isWheelWinner) {
          const newCart = this.$store.cart.filter(item => item.id !== id)
          const res = await this.$api.wheelUpdateCart(
            this.$store.wheelWinner.token,
            newCart
          )
          this.$store.updateCart(res.data.cart)
        } else {
          // API classique pour les participations normales
          const res = await this.$api.syncCart(this.$store.participation.id, {
            action: 'remove',
            product: { id, quantity: 0 }
          })
          this.$store.updateCart(res.data.cart)
        }
      } catch (e) {
        console.log(e)
      }
    },
    closeModal() {
      this.modalCart = false
    },
  },
  async created() {
    // Récupérer le panier existant
    try {
      if (this.isWheelWinner) {
        // Pour les winners wheel, récupérer depuis l'API wheel
        const res = await this.$api.wheelGetWinner(this.$store.wheelWinner.token)
        if (res.data.cart) {
          this.$store.updateCart(res.data.cart)
        }
      } else if (this.$store.participation?.id) {
        // Pour les participations classiques
        const res = await this.$api.getCart(this.$store.participation.id)
        this.$store.updateCart(res.data.cart)
      }
    } catch (e) {
      console.log(e)
    }

    try {
      const res = await this.$api.getProductsTemplate(this.$template.id)
      this.$store.setProducts(res.data)
    } catch (e) {
      console.log(e)
    }

    //remove product from cart if inactive
    for (const key in this.$store.cart) {
      let productActive = this.$store.products.find(product => product.id == this.$store.cart[key].id)
      if (!productActive) {
        this.removeFromCart(this.$store.cart[key].id)
      }
    }
  },
  beforeMount() {
    document.body.style.backgroundColor = 'white'
    window.scrollTo(0, 0);
  },
}
</script>

<style scoped>
.button-validation {
  background-color: v-bind("$template ? $template.products_validate_background_color : ''"
    );
  color: v-bind("$template ? $template.products_validate_text_color : ''");
}

.button-cancel {
  background-color: v-bind("$template ? $template.products_cancel_background_color : ''"
    );
  color: v-bind("$template ? $template.products_cancel_text_color : ''");
}

.button-cart {
  background-color: v-bind("$template ? $template.cart_button_background_color : ''"
    );
  color: v-bind("$template ? $template.cart_button_text_color : ''");
}

.button-car {
  @apply uppercase text-xl p-3 rounded-lg font-bold;
}


.div-form {
  @apply lg:flex w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
